export default {
  'UploadedFileField.RightSideWrapper.DeleteButton': ({ uuid }, outlet) => {
    outlet({ action: { type: 'delete', uuid } })
  },
  'UploadedFileField.RightSideWrapper.HoverTextUnderlineWrapper.SetDefaultButton': ({ uuid }, outlet) => {
    outlet({ action: { type: 'set_default', uuid } })
  },
}
